import { Component, Input, OnInit } from '@angular/core';
import { formatTypes } from '@zipari/shared-ds-util-format';
import { FormattingService } from '../../shared/services/formatting.service';
import { Receipt, ReceiptConfiguration, ReceiptSizes } from './receipt.model';
import { ReceiptService } from './receipt.service';
import { checkInputsForText } from '../../design-system.helper';

@Component({
  selector: 'receipt',
  templateUrl: './receipt.component.html',
  styleUrls: ['./receipt.component.scss'],
})
export class ReceiptComponent implements OnInit {
  @Input() data: Receipt[];
  @Input() config: ReceiptConfiguration;

  ngOnInit(): void {
    const [config, data] = checkInputsForText([this.config, this.data]);

    this.config = config as ReceiptConfiguration;
    this.data = data as Receipt[];
  }

  billDetails$ = this.receiptService.billDetails$;

  public sizes = ReceiptSizes;

  get total() {
    const sum = this.data.reduce((a, b) => a + (b.cost || 0), 0);

    return this.formattingService.restructureValueBasedOnFormat(sum, {
      format: formatTypes.CURRENCY,
    });
  }

  constructor(
    private formattingService: FormattingService,
    private receiptService: ReceiptService,
  ) {}
}
